import { catalogueApi } from "./categoriesApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Category, CreateCategory, UpdateCategory, Subcategory, CreateSubcategory, UpdateSubcategory } from "./categories.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchCategories = createAsyncThunk<
  APIResponse<Category[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/fetchCategories',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.getCategories.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener categorías',
          details: data.details
        });
    }
  }
);


export const fetchCategoryById = createAsyncThunk<APIResponse<Category>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/fetchCategoryById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.getCategoryById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Categoría por ID',
        details: data.details
      });
    }
  }
);


export const createCategory = createAsyncThunk<APIResponse<Category>, CreateCategory,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/createCategory',
  async (data: CreateCategory, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.createCategory.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Categoría',
        details: data.details
      });
    }
  }
);



export const updateCategory = createAsyncThunk<
  APIResponse<Category>,
   { id: number; changes: UpdateCategory }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/updateCategory',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.updateCategory.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Categoría',
        details: data.details
      });
    }
  }
);


export const deleteCategory = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/deleteCategory',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        catalogueApi.endpoints.deleteCategory.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Categoría',
        details: data.details
      });
    }
  }
);


export const fetchSubategories = createAsyncThunk<
  APIResponse<Subcategory[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/fetchSubategories',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.getSubcategories.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener subcategorías',
          details: data.details
        });
    }
  }
);


export const fetchSubcategoryById = createAsyncThunk<APIResponse<Subcategory>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/fetchSubcategoryById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.getSubcategoryById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Subcategoría por ID',
        details: data.details
      });
    }
  }
);


export const createSubcategory = createAsyncThunk<APIResponse<Subcategory>, CreateSubcategory,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/createSubcategory',
  async (data: CreateSubcategory, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.createSubcategory.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear Subcategoría',
        details: data.details
      });
    }
  }
);



export const updateSubcategory = createAsyncThunk<
  APIResponse<Subcategory>,
   { id: number; changes: UpdateSubcategory }, 
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/updateSubcategory',
  async ({ id, changes  }, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        catalogueApi.endpoints.updateSubcategory.initiate({ id, changes  })
      ).unwrap();

      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al actualizar Subcategoría',
        details: data.details
      });
    }
  }
);


export const deleteSubcategory = createAsyncThunk<
  number,
  number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'catalogue/deleteSubcategory',
  async (id , { dispatch, rejectWithValue }) => {
    try {
      await dispatch(
        catalogueApi.endpoints.deleteCategory.initiate(id)
      ).unwrap();
      
      return id;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al eliminar Subcategoría',
        details: data.details
      });
    }
  }
);